


import { keyframes, Skeleton, styled } from '@mui/material';


export const InputBox = styled("input")`
    background-color: white;
    font-size: 1rem;
    width: 90%;
    height: 90%;
    alignSelf: center;
    outline: none;
    padding: 0 4rem;
    border: 2px solid black;
    border-radius: 1.6rem;
`;